import { isNullOrUndefined } from "utils";

export const toleranceToFormula = (formula, tolerance) => {
  const updatedFormula = formula.split(" ").map((i) => {
    const match = tolerance.values.find((v) => i.includes(v.key));
    if (isNullOrUndefined(match)) return i;
    return match.value;
  });

  return updatedFormula?.join(" ");
};

export const normalizeFormula = (formula, values) => {
  let updatedFormula = formula;
  values?.forEach(({ key, value }) => {
    const placeholder = `$${key}`;
    updatedFormula = updatedFormula.replace(new RegExp("\\" + placeholder, "g"), value);
  });
  return updatedFormula;
};
